// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__BFuEB","obliqueLineWrap":"membershipbadge_obliqueLineWrap__KmLcn","obliqueLine":"membershipbadge_obliqueLine__1cJIF"};